function initDeliveryTimer() {
  class DeliveryTimer extends HTMLElement {
    constructor() {
      super();

      this.options = window.theme?.deliveryTimer ?? {};

      const now = new Date();
      this.timezoneConvertedDate = this.convertTimezone(now);

      this.now = {
        day: this.timezoneConvertedDate.getDate(),
        month: this.timezoneConvertedDate.toLocaleString('default', {month: 'long'}),
        year: this.timezoneConvertedDate.getFullYear(),
      };
    }

    init() {
      // Get the time in the specified timezone
      const todayIsValid = this.options.eligible_days.includes(this.timezoneConvertedDate.getDay());

      if (todayIsValid) {
        this.updateMessage();
        this.x = setInterval(this.updateMessage.bind(this), 10000);
        this.classList.remove('hide');
      }
    }

    convertTimezone(date) {
      return new Date(
        (typeof date === 'string' ? new Date(date) : date).toLocaleString('en-US', {timeZone: this.options.timezone})
      );
    }

    updateMessage(thisData) {
      const nowInLoop = new Date();
      const timezoneConvertedDateInLoop = this.convertTimezone(nowInLoop); // current date-time in brisbane.
      const nowTime = timezoneConvertedDateInLoop.getTime();

      // Find the distance between now and the count down date
      const countDownDateTime = new Date(
        `${this.now.day} ${this.now.month}, ${this.now.year} ${this.options.delivery_cutoff}`
      ).getTime();
      const distance = countDownDateTime - nowTime;

      // Time calculations for days, hours, minutes and seconds
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const message = hours > 0 ? `${hours}h, ${minutes}m` : `${minutes}m`;

      this.innerHTML = `<p>${this.options.message.replace('{{ countdown }}', `<strong>${message}</strong>`)}</p>`;

      // Return if the timer needs to keep running
      if (distance > 60000) return;

      // Clear Interval and hide the timer
      if (this.x) clearInterval(this.x);
      this.style.display = 'none';
    }

    connectedCallback() {
      this.init();
    }
  }

  customElements.get('delivery-timer') || customElements.define('delivery-timer', DeliveryTimer);
}

export default initDeliveryTimer;
